import React, { useState } from 'react';
import { Button, Spin } from 'antd';
import { ProfileComponent } from './ProfileComponent';
import ProfileFormContainer from './ProfileFormContainer';
import { useCustomer } from '../../../../../core-module/hooks';

interface Props {
  customerId: number;
}

const ProfileTab: React.FC<Props> = ({ customerId }) => {
  const [showProfileForm, setShowProfileForm] = useState(false);
  const { customer, loading, error } = useCustomer(customerId, showProfileForm);

  if (loading) {
    return <Spin spinning={true}>Profiel aan het ophalen...</Spin>;
  }

  if (error || !customer) {
    return <p>Er is een fout opgetreden bij het ophalen van het profiel.</p>;
  }

  return (
    <>
      {showProfileForm ? (
        <ProfileFormContainer customer={customer} onHideClick={() => setShowProfileForm(false)} />
      ) : (
        <>
          <Button
            onClick={() => setShowProfileForm(true)}
            type='primary'
            icon='edit'
            style={{ marginBottom: 15 }}
          >
            Wijzig
          </Button>
          <ProfileComponent customer={customer} />
        </>
      )}
    </>
  );
};

export { ProfileTab };
